//#region Libraries
import { Column } from "components/styles";
import styled from "styled-components";
//#endregion

export const Container = styled.header`
    display: flex;
    align-items: flex-start;
    gap: 8px;
`;
export const Icon = styled.span`
    & svg {
        width: 25px;
        height: 23px;
    }
`;
export const Content = styled(Column)`
    gap: 10px;
    & * {
        margin: 0;
    }
    & h4 {
        font-size: 20px;
    }
    & p {
        font-size: 14px;
        color: var(--light-gray-5);
    }
`;